import { API_ENDPOINTS } from '@/constants/api';
import { AuthRequired } from '@/shared/components/AuthRequired';
import type { RefreshTokenResponse, User } from '@/shared/types/auth';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { api, setAccessToken, setLoggingOut } from './index';

export const authApi = {
  logout: async (): Promise<void> => {
    setLoggingOut(true);
    try {
      await api.delete(API_ENDPOINTS.AUTH.LOGOUT);
      setAccessToken(null);
      localStorage.removeItem('currentUser');
      sessionStorage.removeItem('currentUser');
      window.location.reload();
    } finally {
      setLoggingOut(false);
    }
  },

  logoutInactivity: (): void => {
    setLoggingOut(true);
    setAccessToken(null);
    localStorage.removeItem('currentUser');
    sessionStorage.removeItem('currentUser');

    // Clear refresh token by making a logout request to invalidate it
    api.delete(API_ENDPOINTS.AUTH.LOGOUT).catch(() => {
      // Ignore errors - we just want to invalidate the refresh token
    });

    const rootElement = document.getElementById('root');
    if (rootElement) {
      const root = createRoot(rootElement);
      root.render(
        React.createElement(AuthRequired, {
          title: 'Session Expired',
          message: 'You have been logged out for security reasons.',
        }),
      );
    }
  },

  refresh: async (): Promise<RefreshTokenResponse> => {
    const response = await api.post<RefreshTokenResponse>(API_ENDPOINTS.AUTH.REFRESH);
    return { accessToken: response.data.accessToken };
  },

  me: async (): Promise<User> => {
    const response = await api.get<User>(API_ENDPOINTS.AUTH.CURRENT_USER);
    return response.data;
  },
};
